export default __webpack_public_path__ + "static/media/hexagons-up.fb731917.svg";